import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from '@tech-environments/environment';
import {
  UntypedFormGroup,
  FormControl,
  Validators,
  UntypedFormBuilder,
  ValidationErrors,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IconDefinition, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { AppConfig } from '@tech-utils/app-config.service';
import { OnExecuteData, ReCaptchaV3Service } from 'ng-recaptcha';
import { Subject, Subscription } from 'rxjs';
import { OnboardingcoreService } from '@tech-services/onboardingcore.service';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from '@tech-services/common.service';

import { SessionService } from '@tech-services/session.service';
import { TechDialogsService } from '../../../shared/tech-dialogs.service';
import { TechConfirmModel } from '../../../shared/techconfirmationdialog/techmodaldialog.model';

@Component({
  selector: 'tech-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.scss'],
})
export class MailComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  public logoUrl =
    './assets/img/' +
    localStorage.getItem('ThemeImg') +
    '/WealthRules-265px.png';
  public form: UntypedFormGroup;
  public hide = true;
  public faSpinner: IconDefinition = null;
  public showfaSpinner: boolean = false;
  public errorMinLength: boolean = true;
  public errorUpcase: boolean = true;
  public errorDowncase: boolean = true;
  public errorDigi: boolean = true;
  public errorChart: boolean = true;
  public errorRealMail: boolean = true;
  public regex: string =
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()_+=,."-¬¡><])[A-Za-z\\d!@#$%^&*()_+=,."-¬¡><]+$';
  public regexUpcase: string = '^(?=.*[A-Z])';
  public regexDowncase: string = '^(?=.*[a-z])';
  public regexDigi: string = '^(?=.*[0-9].*)';
  public regexChart: string = '^(?=.*[!@#$%^&*()_+,.><¬¡-])^[^"\'=]*$';
  public recaptchaToken: string = '';
  public recaptchaSitekey: string = AppConfig.settings.reCaptchaKey;
  public mailExist: boolean = false;
  private captchatoken: string;
  public consent: string;
  private isSMSVerification: boolean = false;

  constructor(
    private translate: TranslateService,
    private fb: UntypedFormBuilder,
    private recaptchaV3Service: ReCaptchaV3Service,
    public onboardingCoreService: OnboardingcoreService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private commonService: CommonService,
    private techDialogsService: TechDialogsService,
    private dialogService: TechDialogsService,
  ) {
    this.newform();
  }

  ngOnInit(): void {
    this.form.statusChanges.subscribe((result) => this.formValidation());

    this.translate.get('k002462').subscribe((text: string) => {
      this.consent = text.replace('{0}', AppConfig.settings.entityName);
    });

    this.isSMSVerification =
      localStorage.getItem('MainSettings') == 'true'
        ? JSON.parse(localStorage.getItem('SmsVerification'))
        : JSON.parse(AppConfig.settings.SMSVerification);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  public newform() {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(AppConfig.settings.minLengthPass),
          this.regexValidator(new RegExp(this.regexUpcase), {
            upcase: 'error',
          }),
          this.regexValidator(new RegExp(this.regexDowncase), {
            downcase: 'error',
          }),
          this.regexValidator(new RegExp(this.regexDigi), {
            digi: 'error',
          }),
          this.regexValidator(new RegExp(this.regexChart), {
            specialchart: 'error',
          }),
        ],
      ],
      checkConsent: ['', []],
    });
  }

  public onSigniup() {
    this.faSpinner = faSpinner;
    this.showfaSpinner = true;
    this.checkMail();
    //this.beforeSubmittingForm();
  }

  public formValidation() {
    if (this.form.controls.email.errors != null) {
      this.form.controls.email.errors.required ||
      this.form.controls.email.errors.email != null
        ? (this.errorRealMail = true)
        : (this.errorRealMail = false);
    } else {
      this.errorRealMail = false;
    }
    if (this.form.controls.password.errors != null) {
      this.form.controls.password.errors.required ||
      this.form.controls.password.errors.minlength != null
        ? (this.errorMinLength = true)
        : (this.errorMinLength = false);
      this.form.controls.password.errors.required ||
      this.form.controls.password.errors.upcase != null
        ? (this.errorUpcase = true)
        : (this.errorUpcase = false);
      this.form.controls.password.errors.required ||
      this.form.controls.password.errors.downcase != null
        ? (this.errorDowncase = true)
        : (this.errorDowncase = false);
      this.form.controls.password.errors.required ||
      this.form.controls.password.errors.digi != null
        ? (this.errorDigi = true)
        : (this.errorDigi = false);
      this.form.controls.password.errors.required ||
      this.form.controls.password.errors.specialchart != null
        ? (this.errorChart = true)
        : (this.errorChart = false);
    } else {
      this.errorMinLength = false;
      this.errorUpcase = false;
      this.errorDowncase = false;
      this.errorDigi = false;
      this.errorChart = false;
    }
  }

  private regexValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  private beforeSubmittingForm(): void {
    this.recaptchaV3Service.execute('registerSubmit').subscribe(
      (token) => {
        this.captchatoken = token;
        this.submitForm();
      },
      (error) => {
        console.log('Error trying to verify request (reCaptcha v3)');
      }
    );
  }

  private checkMail() {
    this.commonService.loading$.emit(true);
    this.recaptchaV3Service.execute('registerSubmit').subscribe(
      (token) => {
        this.captchatoken = token;
        this.onboardingCoreService
          .checkMail(
            encodeURIComponent(this.form.value.email),
            this.captchatoken
          )
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((data) => {
            if (data.exist) {
              this.mailExist = true;
              this.showfaSpinner = false;
              this.commonService.loading$.emit(false);
            } else {
              this.mailExist = false;
              this.saveClient();
              if (this.isSMSVerification) {
                let dialogData = new TechConfirmModel();
                this.translate.get('k002515').subscribe((text) => {
                  dialogData.cancelText = text; //token: Change
                });
                this.translate.get('k002516').subscribe((text) => {
                  dialogData.confirmText = text; //token: Yes, I confirm
                });
                this.translate.get('k002517').subscribe((text) => {
                  dialogData.title = '<center>' + text + '</center>'; //Token: Confirm your email
                });
                this.translate.get('k002518').subscribe((text) => {
                  text = text
                    .replace('{1}', this.form.value.email)
                    .replaceAll('\\"', '"');
                  dialogData.message = '<center>' + text + '</center>'; //Token: By clicking "Yes, I confirm" you agree the email <i>{1}</i> is correct.
                });
                this.commonService.loading$.emit(false);
                this.techDialogsService.openConfirmDialog(dialogData);
                this.techDialogsService
                  .confirmedDialog()
                  .pipe(takeUntil(this.unsubscribe$))
                  .subscribe((data) => {
                    if (data) {
                      this.onboardingCoreService.showSmsVerification = true;
                      this.onboardingCoreService.showSignup = false;
                      this.router.navigate(['/signup/smsverification']);
                    } else {
                      this.showfaSpinner = false;
                    }
                  });
              } else {
                this.beforeSubmittingForm();
              }
            }
          });
      },
      (error) => {
        console.log('Error trying to verify request (reCaptcha v3)');
      }
    );
  }

  public resetmail() {
    this.mailExist = false;
  }
  
  public viewHintHelp(event) {
    let text1: string;
    let text2: string;
    this.translate.get('k004086').subscribe((text: string) => {
      text1 = text; //Token: Caracteres especiales 
    });
    this.translate.get('k004087').subscribe((text: string) => {
      text2 = text; //Token: Por favor, evite los siguientes caracteres: Apóstrofe ('), comillas dobles (\") y símbolo igual (=).
      this.dialogService.openModalDialog('', text1, text2, '');
    });
  }

  private saveClient() {
    this.onboardingCoreService.client.AcceptEmailMarketing = this.form.value
      .checkConsent
      ? true
      : false;
    this.onboardingCoreService.client.AcceptMarketing = this.form.value
      .checkConsent
      ? true
      : false;
    this.onboardingCoreService.client.DisclaimerOnboardingChecked = true;
    this.onboardingCoreService.client.Name = 'NA';
    this.onboardingCoreService.client.Nature = 'Nature';
    this.onboardingCoreService.client.Type = 'NaturalPerson';
    this.onboardingCoreService.client.DocType = 'NA';
    this.onboardingCoreService.client.DocId = 'NA';
    this.onboardingCoreService.client.DocExpirationDate = '1900-01-01';
    this.onboardingCoreService.client.DocExpirationDatePermanent = false;
    this.onboardingCoreService.client.IsResident = true;
    this.onboardingCoreService.client.IsForeigner = false;
    this.onboardingCoreService.client.Language =
      localStorage.getItem('Language');
    this.onboardingCoreService.client.Email = this.form.value.email;
    this.onboardingCoreService.client.Password = this.form.value.password;
    this.onboardingCoreService.client.ServiceModelCode =
      AppConfig.settings.defaultServiceModelCode;
  }

  private submitForm() {
    this.onboardingCoreService
      .createAccount(this.onboardingCoreService.client, this.captchatoken)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.commonService.loading$.emit(false);
        if (!this.isSMSVerification) {
          this.onboardingCoreService.accountConfirmed = true;
          this.onboardingCoreService.showSignup = false;
          this.router.navigate(['/signup/accountconfirmed']);
        }
      });
  }
}
